import React, { useEffect, useMemo, useState } from 'react';
import DropDownSearchable from '../dropDownSearchable';
import { useLazyGetProjectQuery } from '../../store/slices/apiSlice/project-api-slice';
import { handleBackendError } from '../../utilities/errorHandling';
import './scoutProject.css';

export const ProjectSelectorStatus = {
    loading: 'loading',
    error: 'error',
    noselection: 'noselection',
    fulfilled: 'fulfilled',
};

const ProjectSelector = ({ projects, onStatusChange, onProjectSelected }) => {
    const [getProject, getProjectResults] = useLazyGetProjectQuery();
    const [selectedProject, setSelectedProject] = useState(projects[0] || {});

    const projectChoices = useMemo(
        () =>
            projects.map((p) => ({
                value: p?.id,
                label: `${p?.aro_id} - ${p?.alt_name}`,
            })),
        [projects]
    );

    useEffect(() => {
        if (selectedProject?.aro_id) {
            onStatusChange(ProjectSelectorStatus.loading);
            getProject(selectedProject.id);
        }
    }, [selectedProject]);

    useEffect(() => {
        const { isError, status, isSuccess, data } = getProjectResults;
        if (!isError && status === 'fulfilled' && isSuccess) {
            if (data?.error) {
                onStatusChange(ProjectSelectorStatus.error);
                handleBackendError('Get Project Data', data);
            } else {
                onStatusChange(ProjectSelectorStatus.fulfilled);
                onProjectSelected(data);
            }
        }
    }, [getProjectResults]);

    const handleProjectChange = (selected) => {
        const aroId = selected.value;
        const proj = projects.find((p) => p.id === aroId);
        if (proj) {
            setSelectedProject(proj);
        }
    };

    const projectIndex = projectChoices.findIndex(
        (opt) => opt.value === selectedProject.id
    );

    return (
        <div className="projectSelectContainer">
            <DropDownSearchable
                options={projectChoices}
                value={projectChoices[projectIndex]}
                onSelect={handleProjectChange}
                disabled={projectChoices.length <= 1}
                selectedOptionLabelStyles={{
                    fontSize: '18px',
                    fontWeight: 'normal',
                }}
            />
        </div>
    );
};

export default ProjectSelector;
